import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component({})
export default class PopupReportWarningCloseAfterEditComponent extends Vue {
  @appStoreState.Getter
  public getIsShowReportWarningCloseAfterEdit!: boolean;

  @appStoreState.Mutation
  public setIsShowReportWarningCloseAfterEdit!: (payload?: boolean) => void;

  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;

  handleConfirmCloseReportDetail() {
    this.setIsShowReportWarningCloseAfterEdit(false);
    this.setShowDetailReport(false);

    const button = document.getElementById('buttonCloseReportWarningCloseAfterEdit');

    if (button) {
      button.click();
    }

    this.$root.$emit('handleCloseModal');
  }

  handleCancelCloseReportDetail() {
    this.setIsShowReportWarningCloseAfterEdit(false);
  }
}
